import React from 'react';

import XSLXIcon from '@assets/icons/xlsx-file-icon.svg';
import DocxIcon from '@assets/icons/docx-file-icon.svg';
import HtmlIcon from '@assets/icons/html-icon.svg';
import FileTypes from 'Constants/FileTypes';

import { FileTypeIcon, ErrorIcon, UnknownIcon } from '../FileDropzone.styles'

const FileIcon = ({ type }) => {
	if (type === FileTypes.XLSX) {
		return <FileTypeIcon src={XSLXIcon} />
	} else if (type === FileTypes.DOCX) {
		return <img src={DocxIcon} />
	} else if (type === FileTypes.HTML) {
		return <FileTypeIcon src={HtmlIcon} />
	} else if (type === FileTypes.ERROR_TYPE) {
		return <ErrorIcon />
	}
	return <UnknownIcon />
}


export default FileIcon